import { observable} from "mobx";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import LotacaoService from "../../../services/LotacaoService";

const SIM = "Sim";
const NAO = "Não";

export default class LotacaoStore {

    @observable lotacaoLista;
    @observable itemSelecionado;
    @observable loading;

    constructor(modalStore) {
        this.modalStore = modalStore;
        this.lotacaoLista = [];
        this.opcoesEmpresaGlobo = [];
        this.resetItemSelecionado();
        this.empresaGloboService = new EmpresaGloboService();
        this.lotacaoService = new LotacaoService();
        this.carregarEmpresasGlobo();
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            id: 0,
            nome: "",
            ativo: "",
            cnpj: "",
            empresaGloboId: 0,
            nomeEmpresaGlobo:"",
            localEntrega: "",
            organizacaoInventario: "",
            valorCustoVRMot: 0.00
        };
    }

    setEmpresaGloboId(id){
        this.itemSelecionado.empresaGloboId = id;
    }

    setNome(valor){
        this.itemSelecionado.nome = valor;
    }

    setValorCustoVRMot(valor){
        this.itemSelecionado.valorCustoVRMot = valor;
    }

    carregarEmpresasGlobo(){
        this.empresaGloboService.list().then(response =>{
            response.data.map((item)=>{
                if(item.ativo){
                    this.opcoesEmpresaGlobo.push({
                        value:item.id,
                        label: item.nome
                    })
                }
            })
        }).catch(error => {
            console.log(error);
        })
    }

    editar() {
        let tabelaIndex = this.lotacaoLista.findIndex((tabelaItem) => tabelaItem.id === this.itemSelecionado.id);
        let payload = {
            id: this.itemSelecionado.id,
            nome: this.itemSelecionado.nome,
            ativo: this.itemSelecionado.ativo === SIM ? true : false,
            cnpj: this.itemSelecionado.cnpj,
            empresaGloboId: this.itemSelecionado.empresaGloboId,
            localEntrega: this.itemSelecionado.localEntrega,
            organizacaoInventario: this.itemSelecionado.organizacaoInventario,
            valorCustoVRMot: this.itemSelecionado.valorCustoVRMot
        }
        return this.lotacaoService.edit(this.itemSelecionado.id, payload).then(response => {
            let data = response.data
            data.nomeEmpresaGlobo = this.opcoesEmpresaGlobo.filter(x => x.value === data.empresaGloboId)[0].label
            data.ativo = this.itemSelecionado.ativo
            console.log(data)
            this.lotacaoLista[tabelaIndex] = data ;
        })
    }

    carregarLista() {
        this.loading = true;

        const loadingPromises = Promise.all([

            this.lotacaoService.list().then(response => {
                response.data.map((item)=>{
                    this.lotacaoLista.push({
                        id: item.id,
                        nome: item.nome,
                        ativo: item.ativo ? SIM : NAO,
                        cnpj: item.cnpj,
                        empresaGloboId: item.empresaGlobo == null ? "" : item.empresaGlobo.id,
                        nomeEmpresaGlobo:item.empresaGlobo == null ? "" : item.empresaGlobo.nome,
                        localEntrega: item.localEntrega,
                        organizacaoInventario: item.organizacaoInventario,
                        valorCustoVRMot: item.valorCustoVRMot
                    })
                })
            }).catch(error => {
                console.log(error);
            })
        ])
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }


    setLista(value) {
        this.lotacaoLista = value;
    }


    preencherModal(row){
        if(row) {
            this.itemSelecionado = Object.assign({}, row);
        } else {
            this.resetItemSelecionado();
        }
    }
}